import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
// import EleIndex from "@/components/EleIndex.vue";
declare global {
  interface Window {
    US?: any;
  }
}

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const electronWindow = window.US;
onMounted(() => {
  try {
    electronWindow.command((_: any, data: string) => {
      const socketData = decodeURI(data);
      try {
        const parsedData = JSON.parse(socketData);
        if (parsedData.actionType) {
          if (parsedData.actionType === "closeComputer") {
            try {
              if (electronWindow) {
                electronWindow.wakeupLocalApp("closeComputer");
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
      } catch (error) {
        console.error("反序列化失败:", error);
      }
    });
  } catch (error) {
    console.log(error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})